<template>
  <div>
    <div class="right-infp">
      <div class="right-infp-name">
        <el-input placeholder="请输入注册账号" ref="reaccount" v-model="form.account" @keyup.native="val => enterinput(val,'repassword')"  type="text"></el-input>
      </div>
      <div class="right-infp-name">
        <el-input placeholder="请输入密码" ref="repassword" @keyup.native="val => enterinput(val,'shop')" v-model="form.password" type="password"></el-input>
      </div>
      <div class="right-infp-name" ref="shop" v-if="!loginOrRegister&&shoplist.length>1">
        <el-select v-model="form.shop" placeholder="请选择门店" @focus.prevent>
          <el-option
            v-for="item in shoplist"
            :key="item.s_name"
            :label="item.s_name"
            :value="item.s_name"
          >{{item.s_name}}</el-option>
        </el-select>
      </div>
      <div class="right-infp-btn">
        <button class="btn" @click="handle">注册</button>
      </div>
      <div class="right-do" @click="goLogin">去登陆</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    shoplist: {
      type: Array,
      default: [],
    },
    isRegister: {
      type: Boolean,
      result: false,
    },
  },
  data() {
    return {
      form: {
        account: "",
        password: "",
        shop: "",
      },
      loginOrRegister: false,
    };
  },
  mounted() {
  },
  methods: {
    updateIsRegister(bl){
      this.isRegister=bl;
    },
    loginOrRegisterHandle(bl){
      this.isRegister=bl;
    },
    handle() {
		if(this.shoplist.length==1){
			this.form.shop=this.shoplist[0].s_name;
		}
      this.$emit("handle", this.form);
    },
    goLogin() {
      this.$emit("login");
    },
	enterinput(event,control){
		var that=this;
		if (event.keyCode != undefined) {
			if(event.keyCode==13){
				if(control!=undefined){
					if(control=='shop'&&that.shoplist.length>1){
						this.$refs[control].focus();
					}
					else{
						this.handle();
					}
				}else{
					this.handle();
				}
			}
		}
	}
  },
};
</script>